import { IOsaExecucaoProgramaTrabalhoModel, IOsaExecucaoProgramaTrabalhoQuestaoModel } from "./../../../../../models/osa-execucao-programa-trabalho.model";
import { OsaExecucaoProgramaTrabalhoService } from "./../../../../../services/osa-execucao-programa-trabalho.service";
import { OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoResponderComponent } from "./../osa-execucao-aba-folha-teste-programa-trabalho-questao-responder/osa-execucao-aba-folha-teste-programa-trabalho-questao-responder.component";
import { Component, Inject, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, Output, EventEmitter } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import Swal from "sweetalert2";
import { AuthService } from "./../../../../../services/auth.service";
import { OsaExecucaoAbaFolhaTesteQuestaoHistoricoComponent } from "./../osa-execucao-aba-folha-teste-questao-historico/osa-execucao-aba-folha-teste-questao-historico.component";
import { OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoIncidComponent } from "../osa-execucao-aba-folha-teste-programa-trabalho-questao-incid/osa-execucao-aba-folha-teste-programa-trabalho-questao-incid.component";
import { OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoIncidSelecionarComponent } from "../osa-execucao-aba-folha-teste-programa-trabalho-questao-incid-selecionar/osa-execucao-aba-folha-teste-programa-trabalho-questao-incid-selecionar.component";

@Component({
  selector: 'app-osa-execucao-aba-folha-teste-programa-trabalho-questao',
  templateUrl: './osa-execucao-aba-folha-teste-programa-trabalho-questao.component.html',
  styleUrls: ['./osa-execucao-aba-folha-teste-programa-trabalho-questao.component.scss']
})
export class OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoComponent implements OnInit, AfterViewInit {

  public osaExecucaoId: number = 0;
  public id: number = 0;
  public dataSource = new MatTableDataSource<IOsaExecucaoProgramaTrabalhoQuestaoModel>([]);
  public visualizar: boolean = false;
  public titulo: string = "";

  public model: IOsaExecucaoProgramaTrabalhoModel = {} as IOsaExecucaoProgramaTrabalhoModel;
  public numeroOsa: string = "";
  public planejamentoId: number = 0;
  public unidadeGestoraNome: string = "";

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    public matDialog: MatDialog,
    public serviceOsaExecucaoProgramaTrabalho: OsaExecucaoProgramaTrabalhoService,
    private dialogRef: MatDialogRef<OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoComponent>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.osaExecucaoId = data?.osaExecucaoId || 0;
    this.id = data?.id || 0;
    this.visualizar = data?.visualizar || false;
    this.titulo = data?.titulo || '';
    this.numeroOsa = data?.numeroOsa || '';
    this.planejamentoId = data?.planejamentoId || 0;
  }

  ngOnInit(): void {
    this.buscar();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
  }

  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "identificador": return item?.ordem;
      case "descricao": return item?.questao?.nome;
      case "tipo": return item?.tipoDesc;
      case "avaliacao": return item?.avaliacao;
      case "responsavel": return item?.responsavelNome;
      case "status": return item?.status;
      default: return item[property];
    }
  };


  public buscar() {

    this.serviceOsaExecucaoProgramaTrabalho
      .obterProgramaTrabalhoPorId(this.id)
      .then((res) => {
        if (res.sucesso) {
          this.model = res.dados;
          this.unidadeGestoraNome = this.model.unidadeGestora?.sigla || '';

          this.dataSource.data = this.model.questoes || [];

          this.cdr.detectChanges();
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
        }
      })
      .catch((err) => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: err?.mensagem?.descricao || 'Erro ao carregar dados',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      });
  }

  public modalResponder(titulo: string, visualizar: boolean, element?: IOsaExecucaoProgramaTrabalhoQuestaoModel) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-programa-trabalho-questao-responder";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "140vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo,
      visualizar,
      id: element?.id,
      element,
      osaExecucaoId: this.osaExecucaoId,
      unidadeGestoraId: this.model.unidadeGestoraId,
      planejamentoId: this.planejamentoId
    };

    const modal = this.matDialog.open(OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoResponderComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.buscar();
      }
    });
  }

  public modalHistorico(element?: IOsaExecucaoProgramaTrabalhoQuestaoModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-programa-trabalho-questao-historico";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "140vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { id: element?.id, identificador: element?.identificador, idFuncionalidade: 36 };

    const modal = this.matDialog.open(OsaExecucaoAbaFolhaTesteQuestaoHistoricoComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.buscar();
      }
    });
  }

  public addQuestaoIncidental(element: IOsaExecucaoProgramaTrabalhoModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-programa-trabalho-questao-adicionar-incidental";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "90vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Adicionar Questão Incidental",
      visualizar: false,
      alterar: false,
      planejamentoId: this.planejamentoId,
      unidadeGestoraId: this.model.unidadeGestoraId,
      id: 0,
      osaExecucaoProgramaTrabalhoId: element.id,
      ordem: this.gerarProximaOrdem()
    };
    const modal = this.matDialog.open(OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoIncidComponent, dialogConfig);
    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.buscar();
      }
    });
  }

  private abrirFormularioIncidental(element: IOsaExecucaoProgramaTrabalhoModel, questaoOrigem: IOsaExecucaoProgramaTrabalhoQuestaoModel | null) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-programa-trabalho-questao-adicionar-incidental";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "90vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Adicionar Questão Incidental",
      visualizar: false,
      alterar: false,
      planejamentoId: this.planejamentoId,
      unidadeGestoraId: this.model.unidadeGestoraId,
      id: 0,
      osaExecucaoProgramaTrabalhoId: element.id,
      identificador: questaoOrigem ? questaoOrigem.identificador : '',
      ordem: this.gerarProximaOrdem(),
      questaoOrigem: questaoOrigem // ← novo: presença indica modo "reuso"
    };
    const modal = this.matDialog.open(OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoIncidComponent, dialogConfig);
    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.buscar();
      }
    });
  }
  gerarProximaOrdem(): number {
    const ordens = this.model.questoes
      .map(q => q.ordem)
      .filter((o): o is number => o !== null && o !== undefined);

    const maior = ordens.length ? Math.max(...ordens) : 0;
    return maior + 1;
  }

  public alterarQuestaoIncidental(element: IOsaExecucaoProgramaTrabalhoQuestaoModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-programa-trabalho-questao-alterar-incidental";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "90vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Alterar Questão Incidental",
      visualizar: false,
      alterar: true,
      planejamentoId: this.planejamentoId,
      unidadeGestoraId: this.model.unidadeGestoraId,
      id: element.id,
      osaExecucaoProgramaTrabalhoId: element.osaExecucaoProgramaTrabalhoId,
      element
    };
    const modal = this.matDialog.open(OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoIncidComponent, dialogConfig);
    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.buscar();
      }
    });
  }


  public visualizarQuestaoIncidental(element: IOsaExecucaoProgramaTrabalhoQuestaoModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-programa-trabalho-questao-visualizar-incidental";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "90vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Visualizar Questão Incidental",
      visualizar: true,
      alterar: false,
      planejamentoId: this.planejamentoId,
      unidadeGestoraId: this.model.unidadeGestoraId,
      id: element.id,
      osaExecucaoProgramaTrabalhoId: element.osaExecucaoProgramaTrabalhoId,
      element
    };
    const modal = this.matDialog.open(OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoIncidComponent, dialogConfig);
    modal.afterClosed().subscribe((data) => {
      if (data) {
      }
    });
  }

  public excluirQuestaoIncidental(element: IOsaExecucaoProgramaTrabalhoQuestaoModel) {

    Swal.fire({
      title: "Excluir a Questão Incidental",
      text: "Tem certeza que deseja excluir a questão incidental?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.value) {

        this.serviceOsaExecucaoProgramaTrabalho
          .excluirProgramaTrabalhoQuestaoIncidental(element.id)
          .then((res) => {
            if (res.sucesso) {

              this.buscar();

              Swal.fire({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                icon: "success",
                text: res.mensagem.descricao,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          }).finally(() => {
          });
      }
    })
  }

  public fechar() {
    this.dialogRef.close(!this.visualizar);
  }
}
